export const PROMOTIONS_SORT_INDICIZZAZIONE_ASC = "indicizzazione_asc";
export const PROMOTIONS_SORT_INDICIZZAZIONE_DESC = "indicizzazione_desc";

export const PROMOTIONS_SORT_PERCENTUALE_ASC = "percentuale_asc";
export const PROMOTIONS_SORT_PERCENTUALE_DESC = "percentuale_desc";

export const PROMOTIONS_SORT_POSIZIONE_ASC = "posizione_asc";
export const PROMOTIONS_SORT_POSIZIONE_DESC = "posizione_desc";

